<section class="page-container memberDirectory">

    <div class="container-fluid h-100">

        <div class="memberDirectoryContent h-100">
            <div class="row h-100">

                <div class="col-md-6 p-3 directoryContainer h-100"
                    [ngClass]="{'col-md-6': showMap, 'col-md-12': !showMap}" id="directoryContainer">

                    <div class="directoryInner h-100">
                        <h1 class="mb-3">MEMBER DIRECTORY</h1>

                        <div class="row mb-3 pb-3">

                            <div class="col-12 mb-3">
                                <div class="mainSearch">
                                    <div class="searchContainer">
                                        <div class="searchBox m-100">
                                            <input [(ngModel)]="searchText" (search)="searchDirectory(true)"
                                                   type="search" class="form-control"
                                                   placeholder="search our member directory...">
                                            <button (click)="searchDirectory(true)" type="button"
                                                    class="btn btn-secondary m-100">
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto mb-3">
                                <label for="website" class="form-label">Industry</label>
                                <select [(ngModel)]="industrySearchText" class="form-select" aria-label="industry" id="industry" (change)="searchDirectory(true)">
                                    <option *ngFor="let ind of industryOptions" value="{{ind}}">{{ind}}</option>
                                </select>
                            </div>


                            <!-- <div class="col-xl-6">
            <input id="filter-input" class="mobi-input form-control" data-dropdown="true" placeholder="All Industries" />
            <select id="filter-select" multiple>
                <option value="1">industry</option>
                <option value="2">industry</option>
            </select>
        </div> -->

                        </div>

                        <hr />

                        <div class="row my-3 align-items-center">
                            <div class="col-md-6">
                                <div *ngIf="finalSearchText != ''" class="directoryResults">
                                    {{totalResults}} Result(s) for "{{finalSearchText}}"
                                </div>
                            </div>
                            <div class="col-md-6 text-end">
                                <div class="mapToggle">
                                    <div class="btn-group" role="group" aria-label="Map Toggle">
                                        <button *ngIf="!showMap" (click)="showMap = true" type="button"
                                                class="btn btn-primary" id="toggleMapOn">
                                            <i class="fa-regular fa-location-dot"></i>
                                        </button>
                                        <button *ngIf="showMap" (click)="showMap = false" type="button"
                                                class="btn btn-primary" id="toggleMapOff">
                                            <i class="fa-regular fa-location-dot-slash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="adUrl1 != null && adUrl1 != ''" class="placeholderAd1Wrap">
                            <div class="placeholderAd placeholderAd1" >
                                <a href="{{(ad1Link.startsWith('http')) ? '' : 'https://'}}{{ad1Link}}" target="_blank" rel="noopener noreferrer"><img src="{{adUrl1}}" /></a>
                            </div>
                        </div>

                        <div class="directoryListWrap row row-cols-1 row-cols-xl-2 row-cols-lg-1 row-cols-md-1 row-cols-sm-1 g-4">

                            <div *ngFor="let member of members" class="col">
                                <div class="directoryCard card h-100">
                                    <div class="industryIconWrap">
                                        <span class="industryIcon">
                                            <i class="fa-regular fa-star"></i>
                                        </span>
                                    </div>
                                    <div class="directoryShort">
                                        <div class="directoryName">
                                            {{member.memberName}}
                                        </div>
                                        <div class="directoryMembership">
                                            <span class="membershipBadge" [ngClass]="{'silver': [member.membershipLevel == 1, member.membershipLevel == 9]
                                            , 'gold': member.membershipLevel == 2
                                            , 'signature': member.membershipLevel == 4
                                            , 'private': member.membershipLevel == 5
                                            , 'commercial': member.membershipLevel == 6
                                            , 'leadership': member.membershipLevel == 7
                                            }">
                                                {{member.membershipLevelString}}
                                            </span>
                                        </div>
                                        <div class="directoryBlurb" [innerHTML]="member.memberDescription">
                                        </div>
                                        <a [routerLink]="['/public/member-profile', member.companyId]"
                                           class="directoryMore" target="_blank">view more</a>
                                        <span *ngIf="member.locations.length > 1">
                                            |
                                            <a href="javascript:void(0);" class="directoryMore"
                                               (click)="openViewLocationsModal(member)">
                                                show all
                                                {{member.locations.length}}
                                                locations
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div *ngIf="adUrl2 != null && adUrl2 != ''" class="placeholderAd1BWrap">
                            <div class="placeholderAd placeholderAd1B">
                                <a href="{{(ad2Link.startsWith('http')) ? '' : 'https://'}}{{ad2Link}}" target="_blank" rel="noopener noreferrer"><img src="{{adUrl2}}" /></a>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-12">
                                <div class="paginationWrap">
                                    <nav aria-label="Indy Chamber member directory pagination">
                                        <ngb-pagination class="pagination paginationFloaty justify-content-center" [maxSize]="4" [ellipses]="true"
                                                        [collectionSize]="totalResults" [(page)]="currentPageNum" [pageSize]="itemsPerPage">
                                        </ngb-pagination>

                                        <!-- <ul class="pagination paginationFloaty justify-content-center">
                        <li *ngIf="page > 0" class="page-item">
                            <a class="page-link" href="javascript:void(0)" aria-label="Previous" (click)="prevPage()">
                                <span aria-hidden="true">« Previous</span>
                            </a>
                        </li>
                        <li *ngFor="let item of [].constructor(totalPages);
                            let i = index" class="page-item" [ngClass]="{'active': page == i}">
                            <a class="page-link" (click)="goToPage(i)"
                                href="javascript:void(0)">{{i+1}}</a>
                        </li>
                        <li class="page-item" *ngIf="page < totalPages">
                            <a class="page-link" href="javascript:void(0)" aria-label="Next" (click)="nextPage()">
                                <span aria-hidden="true">Next »</span>
                            </a>
                        </li>
                    </ul> -->
                                    </nav>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>



                <div class="col-md-6 g-0 h-100 directoryMap" [ngClass]="{'col-md-6': showMap, 'd-none': !showMap}"
                    id="directoryMap">

                    <!-- start example map icons -->
                    <!-- <div class="demoMapDot" style="top: 50%; right: 50%;">
                        <img src="../images/location-dot.png" alt="demo map dot"/>
                    </div>
                    <div class="demoMapDot" style="top: 30%; right: 20%;">
                        <img src="../images/location-dot.png" alt="demo map dot"/>
                    </div>
                    <div class="demoMapDot" style="top: 10%; right: 90%;">
                        <img src="../images/location-dot.png" alt="demo map dot"/>
                    </div>
                    <div class="demoMapDot" style="top: 90%; right: 60%;">
                        <img src="../images/location-dot.png" alt="demo map dot"/>
                    </div> -->
                    <!-- end example map icons -->

                    <div class="mapCanvas" #map>

                    </div>


                </div>
            </div>
        </div>
    </div>



</section>